import { registerModal } from 'features/Modal/ModalRegistry'
import BlogFilterModal from './BlogFilterModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'BLOG_FILTER'
registerModal(modalType, BlogFilterModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogFilterModal/BlogFilterModal.action.js